module.exports = __webpack_public_path__ + "video/500_KMSAT15_2022_Common_Digital_Attacks-Spear_Phishing.09eb55f7.vtt";